export default "__VITE_ASSET__61881357__"